import { useRef, useState, ChangeEvent, DragEvent } from "react";

export const useFileUpload = () => {
    const [drag, setDrag] = useState(false);
    const [fileNames, setFileNames] = useState<string[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const [inputValue, setInputValue] = useState<string>('');

    const handleFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileRemove = (index: number) => {
        const updatedFiles = [...uploadedFiles];
        updatedFiles.splice(index, 1);
        const updatedFileNames = [...fileNames];
        updatedFileNames.splice(index, 1);
        setUploadedFiles(updatedFiles);
        setFileNames(updatedFileNames);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const newFiles = Array.from(e.target.files);
            const newFileNames = newFiles.map((file) => file.name);
            setUploadedFiles((prevUploadedFiles) => [...prevUploadedFiles, ...newFiles]);
            setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
            setInputValue('');
        }
    };

    const dragStartHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setDrag(true);
    };

    const dragLeaveHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setDrag(false);
    };

    const onDropHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        setUploadedFiles((prevUploadedFiles) => [...prevUploadedFiles, ...files]);
        setFileNames((prevFileNames) => [...prevFileNames, ...files.map((file) => file.name)]);
        setDrag(false);
    };

    return {
        drag,
        fileNames,
        uploadedFiles,
        fileInputRef,
        inputValue,
        handleFileUpload,
        handleFileRemove,
        handleFileChange,
        dragStartHandler,
        dragLeaveHandler,
        onDropHandler,
        setFileNames,
        setUploadedFiles
    };
};


